module.exports = __webpack_public_path__ + "40bb79783e1ce622f02166a226cef75e.jpg";